<template>

    <div>
<!--        <div class="refresh-progress-container">-->
<!--            <el-progress-->
<!--                :percentage="refreshProgress"-->
<!--                :show-text="false"-->
<!--                :stroke-width="10"    style="margin-bottom: 10px;"-->
<!--                color="#409EFF"-->
<!--            ></el-progress>-->
<!--            <p class="refresh-text">页面将在 {{ refreshCountdown }} 秒后刷新</p>-->
<!--        </div>-->
        <div class='panBody'  ref="panBody">
            <el-row :gutter="0">
                <el-col>
                    <el-row :gutter="4" class="mgb20">
                        <el-col :span="3">
                            <el-card shadow="alwyas">
                                <div class="grid-content grid-con-1">
                                    <i class="el-icon-c-scale-to-original grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num" v-animate-number="orderNum.total" ></div>
                                        <div>累计进单数量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="3">
                            <el-card shadow="hover">
                                <div class="grid-content grid-con-2">
                                    <i class="el-icon-guide grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num" style="color: #f56c6c;" v-animate-number="orderNum.success"> </div>
                                        <div>累计订购量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="3">
                            <el-card shadow="hover">
                                <div class="grid-content grid-con-3">
                                    <i class="el-icon-finished grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num with-percent" style="color: #67c23a"  v-animate-number="orderNum.overallAverageConversion">  </div>
                                        <div>整体平均转化</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
<!--                    <div class="row">-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->

<!--                                    <h3 class="funfact-one__title counter" style="color:#f56c6c;"-->
<!--                                        v-animate-number="orderNum.lastMonthSuccessOrder">-->
<!--                                         </h3>-->

<!--                                    <p class="funfact-one__tag-line">上月订购量</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <el-tooltip  :content="`本月预估订购量：${orderNum.estimateOrderThisMonth}`" placement="bottom" effect="light">-->
<!--                            <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                                <div class="funfact-one__single-outer">-->
<!--                                    <div class="funfact-one__single">-->

<!--                                        <h3 class="funfact-one__title counter" style="color:#67c23a;">-->
<!--                                            <i v-if="orderNum.lastMonthSuccessOrder < orderNum.estimateOrderThisMonth"-->
<!--                                               class="el-icon-top" style="color: #67c23a;"></i>-->
<!--                                            <i v-else-if="orderNum.lastMonthSuccessOrder > orderNum.estimateOrderThisMonth"-->
<!--                                               class="el-icon-bottom" style="color: #f56c6c;"></i>-->
<!--                                            <span v-animate-number="orderNum.successOrderThisMonth">{{ orderNum.successOrderThisMonth }}</span>-->
<!--                                        </h3>-->
<!--                                            <p class="funfact-one__tag-line">本月订购量</p>-->

<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-tooltip>-->


<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title counter" style="color:#f56c6c;"-->
<!--                                        v-animate-number="orderNum.successOrderLastWeek"-->
<!--                                    >-->
<!--                                     </h3>-->
<!--                                    <p class="funfact-one__tag-line">上周订购量</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title counter" style="color:#67c23a"-->
<!--                                        v-animate-number="orderNum.successOrderThisWeek"-->
<!--                                    >-->
<!--                                         </h3>-->

<!--                                    <p class="funfact-one__tag-line">本周订购量</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title counter" style="color:#f56c6c;"-->
<!--                                        v-animate-number="orderNum.successOrderLastDay"-->
<!--                                    > </h3>-->
<!--                                    <p class="funfact-one__tag-line">昨日订购量</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title counter" style="color:#67c23a;"-->
<!--                                        v-animate-number="orderNum.successOrderToday"-->
<!--                                    >-->
<!--                                        </h3>-->
<!--                                    <p class="funfact-one__tag-line">今日订购量</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->


                        <div class="row data-row">
                            <!-- 第一组 -->
                            <div class="data-block">
                                <div class="data-item left-item">
                                    <div class="data-content">
                                        <h3 v-animate-number="orderNum.lastMonthSuccessOrder">
                                            {{ orderNum.lastMonthSuccessOrder }}</h3>
                                        <p>上月订购量</p>
                                    </div>
                                    <div class="hover-layer"></div>
                                </div>
                                <div class="data-item right-item">
                                    <div class="data-content">
                                        <el-tooltip :content="`本月预估订购量：${orderNum.estimateOrderThisMonth}`"
                                                    placement="top" effect="light">
                                            <h3 style="color:#67c23a;">
                                                <i v-if="orderNum.lastMonthSuccessOrder < orderNum.estimateOrderThisMonth"
                                                   class="el-icon-top" style="color: #67c23a;"></i>
                                                <i v-else-if="orderNum.lastMonthSuccessOrder > orderNum.estimateOrderThisMonth"
                                                   class="el-icon-bottom" style="color: #f56c6c;"></i>
                                                <span
                                                    v-animate-number="orderNum.successOrderThisMonth">{{ orderNum.successOrderThisMonth
                                                    }}</span>
                                            </h3>
                                        </el-tooltip>
                                        <p>本月订购量</p>
                                    </div>
                                    <div class="hover-layer"></div>
                                </div>
                            </div>

                            <!-- 第二组 -->
                            <div class="data-block">
                                <div class="data-item left-item">
                                    <div class="data-content">
                                        <h3 v-animate-number="orderNum.successOrderLastWeek">
                                            {{ orderNum.successOrderLastWeek }}</h3>
                                        <p>上周订购量</p>
                                    </div>
                                    <div class="hover-layer"></div>
                                </div>
                                <div class="data-item right-item">
                                    <div class="data-content">
                                        <h3 v-animate-number="orderNum.successOrderThisWeek">
                                            {{ orderNum.successOrderThisWeek }}</h3>
                                        <p>本周订购量</p>
                                    </div>
                                    <div class="hover-layer"></div>
                                </div>
                            </div>

                            <!-- 第三组 -->
                            <div class="data-block">
                                <div class="data-item left-item">
                                    <div class="data-content">
                                        <h3 v-animate-number="orderNum.successOrderLastDay">
                                            {{ orderNum.successOrderLastDay }}</h3>
                                        <p>昨日订购量</p>
                                    </div>
                                    <div class="hover-layer"></div>
                                </div>
                                <div class="data-item right-item">
                                    <div class="data-content">
                                        <h3 v-animate-number="orderNum.successOrderToday">{{ orderNum.successOrderToday
                                            }}</h3>
                                        <p>今日订购量</p>
                                    </div>
                                    <div class="hover-layer"></div>
                                </div>
                            </div>
                        </div>


                        <!-- /.row -->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->

<!--                                    <h3 class="funfact-one__title with-percent counter" style="color:#f56c6c;"-->
<!--                                        v-animate-number="orderNum.lastMonthAverageConversion"-->
<!--                                    >-->
<!--                                          </h3>-->
<!--                                    <p class="funfact-one__tag-line">上月转化率</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title with-percent counter" style="color:#67c23a;"-->
<!--                                        v-animate-number="orderNum.averageConversionThisMonth"-->
<!--                                    >-->
<!--                                         </h3>-->
<!--                                    <p class="funfact-one__tag-line">本月转化率</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title  with-percent counter"-->
<!--                                        v-animate-number="orderNum.averageConversionLastWeek"-->
<!--                                        style="color:#f56c6c;">-->
<!--                                       </h3>-->
<!--                                    <p class="funfact-one__tag-line">上周转化率</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title with-percent counter"-->
<!--                                        v-animate-number="orderNum.averageConversionThisWeek"-->
<!--                                        style="color:#67c23a">-->
<!--                                        </h3>-->

<!--                                    <p class="funfact-one__tag-line">本周转化率</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title with-percent counter"-->
<!--                                        v-animate-number="orderNum.averageConversionLastDay"-->
<!--                                        style="color:#f56c6c;">-->
<!--                                         </h3>-->
<!--                                    <p class="funfact-one__tag-line">昨日转化率</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-lg-3 col-md-6 col-sm-12">-->
<!--                            <div class="funfact-one__single-outer">-->
<!--                                <div class="funfact-one__single">-->
<!--                                    <h3 class="funfact-one__title  with-percent counter"-->
<!--                                        v-animate-number="orderNum.averageConversionToday"-->
<!--                                        style="color:#67c23a;">-->
<!--                                        </h3>-->
<!--                                    <p class="funfact-one__tag-line">今日转化率</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <el-row :gutter="0" >
                        <el-col :span="24">
                            <el-card shadow="hover" v-loading="schartLoading">
                                <schart style=" height: 300px;" ref="line" class="schart" canvasId="line" :options="options2"></schart>
                            </el-card>
                        </el-col>
                        <el-col :span="24">
                            <el-card shadow="hover"  v-loading="schartLoading ||channelLoading">
                                <div style="display: flex; justify-content: flex-end; width: 100%;">
                                    <el-button-group>
                                        <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics30('channel-today')" >今日</el-button>
                                        <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics30('channel-7day')">近七天</el-button>
                                        <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics30('channel-30day')">近三十天</el-button>
                                    </el-button-group>
                                </div>
                                <schart style=" height: 300px;" ref="bar" class="schart" canvasId="bar"
                                        :options="option1"></schart>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row :gutter="0">
                        <el-col :span="24">
                            <el-card shadow="hover" v-loading="schartLoading">
                                <schart style=" height: 300px;" ref="line3" class="schart" canvasId="line3" :options="options3"></schart>
                            </el-card>
                        </el-col>
                        <el-col :span="24">
                            <el-card shadow="hover" v-loading="schartLoading">
                                <schart style=" height: 300px;" ref="line4" class="schart" canvasId="line4" :options="options4"></schart>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-card shadow="hover" v-loading="schartLoading || productLoading" style="height: 400px; overflow-y: auto;">
                        <div slot="header" class="clearfix  header-row">
                            <span>近30天产品销售({{ lastTotalAvg }})占比</span>
                            <div class="button-group-wrapper">
                                <el-button-group>
                                    <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics30('product-today')">今日</el-button>
                                    <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics30('product-7day')">近七天</el-button>
                                    <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics30('product-30day')">近三十天</el-button>
                                </el-button-group>
                            </div>
                        </div>

                        <div class="progress-card" v-for="item in option4" :key="item.dateString">
                            <div class="progress-header">
                                <div class="progress-title">
                                    <i class="el-icon-timer"></i>
                                    <span>{{ item.dateString }}</span>
                                </div>
                            </div>
                            <el-progress
                                class="custom-progress"
                                :format="(percentage) => formatProgress(percentage, item)"
                                :stroke-width="8"
                                :percentage="item.progress"
                                color="#5cb87a"
                            ></el-progress>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
<!--        <div ref="chart" style="width: 600px; height: 400px;"></div>-->
    </div>

</template>

<script>
import bus from '../../common/bus';  
import Schart from 'vue-schart';
import * as echarts from 'echarts';
import { findOrderStatistics, dataStatistics30 ,findDataByTodayAndThisMonth} from '../../../api/orderStatistics/orderStatustucs';
import channel from '@/view/channel/Channel.vue';

export default {
    name: 'charts',
    data() {
        return {
            schartLoading: false,
            channelLoading: false,
            productLoading: false,
            lastTotalAvg: 0,
            query: { dataType: '1' },
            refreshProgress: 100, // 初始进度为100%
            refreshCountdown: 10, // 初始倒计时为10秒
            refreshInterval: null ,// 存储定时器ID
            orderNum: {
                total:0,
                success:0,
                overallAverageConversion:0,
                lastMonthSuccessOrder:0,
                estimateOrderThisMonth:0,
                successOrderThisMonth:0,
                successOrderLastWeek:0,
                successOrderThisWeek:0,
                successOrderLastDay:0,
                successOrderToday:0,
                lastMonthAverageConversion:0,
                averageConversionThisMonth:0,
                averageConversionLastWeek:0,
                averageConversionThisWeek:0,
                averageConversionLastDay:0,
                averageConversionToday:0
            },
            option1: {
                type: 'bar',
                title: {
                    text: '近30天渠道销售图'
                },
                xRorate: 25,
                labels: ['渠道A', '渠道B', '渠道C', '渠道D', '渠道E'],
                datasets: [
                    {
                        label: '渠道',
                        data: [234, 278, 270, 190, 230]
                    }
                ]
            },
            options2: {

                axisLabel: {
                    interval: 0,
                    rotate: 10 // 关键点：旋转标签
                },
                type: 'line',
                title: {
                    text: '近30天订单增长趋势图'
                },
                labels: [],
                datasets: [
                    {
                        label: '订单增长',
                        data: []
                    }
                ]
            },
            options3: {

                axisLabel: {
                    interval: 0,
                    rotate: 10 // 关键点：旋转标签
                },
                type: 'line',
                title: {
                    text: '今日订单增长图'
                },
                labels: [],
                datasets: [
                    {
                        label: '订购量',
                        data: []
                    },
                    {
                        label: '进单量',
                        data: []
                    }
                ]
            },
            options4: {
                axisLabel: {
                    interval: 0,
                    rotate: 10 // 关键点：旋转标签
                },
                type: 'line',
                title: {
                    text: '本月订单增长图'
                },
                labels: [],
                datasets: [
                    {
                        label: '订购量',
                        data: []
                    },
                    {
                        label: '进单量',
                        data: []
                    }
                ]
            },

            option4: []


        };
    },
    components: {
        Schart
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
        // 记得移除监听，避免内存泄漏
        bus.$off('data-body1');

        const container = this.$refs.panBody;
        if (container) {
            container.removeEventListener('wheel', this.onUserInteraction);
        }

        window.removeEventListener('keydown', this.onUserKeyDown);
    },
    mounted() {

        this.getOrderStatistics();
        // //自动刷新
        this.startRefreshCountdown();
        // 自动滚动逻辑开始
        // 06-16 14:36 辉哥强烈要求删掉自动滚动,他说滚的真他妈烦
        // this.$nextTick(() => {
        //     this.startAutoScroll();
        // });
         
    },
    computed: {},
    created() {
        
    },
    methods: {
        startAutoScroll() {
            let direction = 'down'; // down / up
            let duration = 20000;   // 动画总时长：20秒
            let startTime = null;
            let pauseTimer = null;

            const container = this.$refs.panBody;

            // 状态控制
            this.isPaused = false;

            // 恢复自动滚动函数
            const resumeAutoScroll = () => {
                if (this.isPaused) {
                    console.log('用户操作，暂停中...');
                    clearTimeout(pauseTimer);
                    pauseTimer = setTimeout(() => {
                        console.log('10秒静默结束，恢复滚动');
                        this.isPaused = false;
                        container.scrollTop = 0; // 回到顶部重新开始
                        startTime = null;
                        requestAnimationFrame(animateScroll);
                    }, 10000); // 10秒后恢复
                }
            };

            // 用户操作监听
            const onUserInteraction = () => {
                this.isPaused = true;
                resumeAutoScroll();
            };

            // 绑定事件监听器
            container.addEventListener('wheel', onUserInteraction);
            window.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                    onUserInteraction();
                }
            });

            // 动画函数
            const animateScroll = (timestamp) => {
                if (this.isPaused) return;

                if (!startTime) startTime = timestamp;
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);

                const scrollHeight = container.scrollHeight;
                const clientHeight = container.clientHeight;
                const maxScrollTop = scrollHeight - clientHeight;

                let targetScrollTop = direction === 'down'
                    ? progress * maxScrollTop
                    : (1 - progress) * maxScrollTop;

                container.scrollTop = targetScrollTop;

                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                } else {
                    direction = direction === 'down' ? 'up' : 'down';
                    startTime = null;
                    requestAnimationFrame(animateScroll);
                }
            };

            requestAnimationFrame(animateScroll);
        },
        startRefreshCountdown() {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }

            this.refreshInterval = setInterval(() => {
                this.refreshCountdown--;
                this.refreshProgress = Math.max(0, (this.refreshCountdown / 10) * 100);

                if (this.refreshCountdown < 0) {
                    console.log('页面即将刷新...');

                    this.getOrderStatistics(); // 刷新数据，不刷新页面

                }
            }, 60000*5);
        },


        formatProgress(percentage, item) {
            return `订购量：${item.success} | 转化率：${item.avg}% | 销售占比：${percentage}%`;
        },
        getOrderStatistics30(type) {
            console.log('type===>' + type);
            let query = {
                type: type
            };
            if (type.startsWith("channel")){
                this.channelLoading = true;
            }else {
                this.productLoading = true;
            }
            dataStatistics30(query).then(res => {
                if (res.code == '200') {
                    if (type.startsWith("channel")){

                        let option1Sum = res.data.channelOrderData.longs.reduce((total, current) => total + current, 0);
                        if (!option1Sum){
                            option1Sum  = 0;
                        }
                        this.option1.title.text =   '近30天渠道销售图 总计(' + option1Sum + ') ';
                        this.option1.labels = res.data.channelOrderData.cnames;
                        this.option1.datasets[0].data = res.data.channelOrderData.longs;

                    }else {

                        this.option4 = res.data.products;
                        if (res.data.products){
                            this.lastTotalAvg = res.data.products.reduce((sum, item) => sum + item.success, 0);
                        }else{
                            this.lastTotalAvg = 0;
                        }
                    }

                    this.channelLoading=false;
                    this.productLoading = false;
                    console.log('dataStatistics30接口返回=====>' , res);
                }

            });

        },
        getOrderStatistics() {

            findOrderStatistics().then(res => {
                if (res.code == '200') {
                    Object.keys(res.data).forEach(key => {
                        this.orderNum[key] = res.data[key];
                    });
                    console.log('接口返回=====>' + this.orderNum);
                }
            });
            this.schartLoading = true;
            dataStatistics30().then(res => {
                if (res.code == '200') {

                    const sum = res.data.orderInrData.numList.reduce((total, current) => total + current, 0);
                    console.log('总和为：', sum);
                    this.options2.title.text =  ' 近30天订单增长趋势图 总计(' + sum + ') ';
                    this.options2.labels = res.data.orderInrData.dateList || [];
                    this.options2.datasets[0].data = res.data.orderInrData.numList;

                    const option1Sum = res.data.channelOrderData.longs.reduce((total, current) => total + current, 0);
                    this.option1.title.text =   '近30天渠道销售图 总计(' + option1Sum + ') ';
                    this.option1.labels = res.data.channelOrderData.cnames;
                    this.option1.datasets[0].data = res.data.channelOrderData.longs;
                    this.option4 = res.data.products;
                    this.lastTotalAvg = res.data.products.reduce((sum, item) => sum + item.success, 0);
                    console.log('dataStatistics30接口返回=====>' + this.orderNum);
                }
                this.schartLoading =false;
            });

            findDataByTodayAndThisMonth().then(res => {
                if (res.code == '200') {
                    console.log('findDataByTodayAndThisMonth接口返回=====>' , res)
                    let reduce = res.data.successList.reduce((total, current) => total + current, 0);
                    this.options3.title.text =  ' 今日订单增长趋势图 订购总计(' + reduce + ') ';
                    this.options3.labels = res.data.xList || [];
                    this.options3.datasets[0].data = res.data.successList;
                    this.options3.datasets[1].data = res.data.totalList;

                    let reduce3 = res.data.successDayList.reduce((total, current) => total + current, 0);
                    this.options4.title.text =  ' 本月订单增长趋势图 订购总计(' + reduce3 + ') ';
                    this.options4.labels = res.data.xDayList || [];
                    this.options4.datasets[0].data = res.data.successDayList;
                    this.options4.datasets[1].data = res.data.totalDayList;
                }

            })


        }
    }
};
</script>


<style>
.funfact-one {
    padding-top: 60px;
}

.funfact-one .block-title {
    margin-bottom: 20px;
}

.funfact-one__single {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    background-color: white;
    width: 100%;
    height: 150px;
    margin-left: auto;
    margin-right: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;
}

.funfact-one__single-outer {
    display: inline-block;
}

.funfact-one__single:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #98caff;

    -webkit-transform: scale(0, 0);
    transform: scale(0, 0);
    -webkit-transition: -webkit-transform .4s ease;
    transition: -webkit-transform .4s ease;
    transition: transform .4s ease;
    transition: transform .4s ease, -webkit-transform .4s ease;
}

.funfact-one__single:hover:before {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
}

.funfact-one__single:hover .funfact-one__title, .funfact-one__single:hover .funfact-one__tag-line {
    color: #fff;
}

.funfact-one__title {
    margin: 0;
    color: #111;
    font-size: 34px;
    letter-spacing: -0.04em;
    line-height: 1em;
    position: relative;
    -webkit-transition: all .4s ease;
    transition: all .4s ease;
}

.funfact-one__tag-line {
    color: #8B8C9C;
    font-size: 15px;
    letter-spacing: .2em;
    margin: 0;
    text-transform: uppercase;
    line-height: 1em;
    margin-top: 20px;
    position: relative;
    -webkit-transition: all .4s ease;
    transition: all .4s ease;
}

[class*=funfact-one__dot-] {
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: #ef7c19;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: dotsAnim;
    animation-name: dotsAnim;
    -webkit-animation-timing-function: cubic-bezier(0.39, 0.58, 0.57, 1);
    animation-timing-function: cubic-bezier(0.39, 0.58, 0.57, 1);
    -webkit-animation-duration: 5s;
    animation-duration: 5s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}

.funfact-one__dot-1 {
    top: 45px;
    left: 60px;
}

.funfact-one__dot-2 {
    left: 45px;
    bottom: 60px;
}

.funfact-one__dot-3 {
    right: 45px;
    top: 120px;
}

.el-progress {
    margin-bottom: 15px;
}

.col-lg-3 {
    display: inline;
    width: 33%;
}

.el-col-8 {
    width: 50%;
}

@media screen and (max-width: 999px) {

    .el-row {
        margin-bottom: 10px;
    }

    .el-card__body, .el-main {
        padding: 0;
    }

    .grid-con-icon {
        display: inline-block;
        font-size: 30px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
    }

    .grid-content {
        display: flex;
        align-items: left;
        height: 50px;
    }

    .grid-num {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 12px;
        color: #999;
    }



    .user-info-cont div:first-child {
        font-size: 25px;
        color: #222;
    }

    .funfact-one__single-outer {
        width: 33.3%;
        margin-bottom: 10px;
    }

    .funfact-one__single {
        height: 100px;
    }

    .funfact-one__title {
        font-size: 20px;
    }

    .funfact-one__tag-line {
        font-size: 12px;
    }

}

@media screen and (min-width: 1000px) {
    .funfact-one__single-outer {
        width: 16.6%;
        margin-bottom: 20px;
    }

    .el-row {
        margin-bottom: 30px;
    }

    .grid-con-icon {
        display: inline-block;
        font-size: 50px;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        color: #fff;
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 100px;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    }

    .user-avator {
        width: 120px;
        height: 120px;
    }

    .user-name {
        font-size: 15px;
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }
}

.refresh-progress-container {


}

.refresh-text {
    font-size: 14px;
    color: #666;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: #f56c6c;
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: #67c23a
}

.grid-con-3 .grid-num {
    color: #67c23a
}

.el-col-3 {

    min-width: calc(33.33% );
}


.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 10px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 350px;
}

.panBody {
    height: calc(100vh - 60px); /* 减去 header 高度 */
    overflow-y: auto;
}

.wid2 {
    width: 50%;
    float: left;
}
.with-percent::after {
    content: '%';
    margin-left: 4px;
}
.progress-date {
    display: inline-block;
    width: 600px; /* 固定宽度便于对齐 */
    font-size: 14px;
    color: #666;
    margin-right: 16px;
}

.custom-progress {
    display: inline-block;
    width: 100%; /* 配合日期宽度 */
    vertical-align: middle;
    margin-bottom: 12px;
}

.el-progress__text {
    font-size: 13px;
    color: #555;
    margin-left: 8px;
}
.progress-item {
    margin-bottom: 16px;
    padding: 8px 12px;
    background-color: #f9f9f9;
    border-radius: 6px;
    transition: background-color 0.3s ease;
}

.progress-item:hover {
    background-color: #f1f1f1;
}

.progress-card {
    background-color: #f9f9f9;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);
    transition: all 0.3s ease;
}

.progress-card:hover {
    background-color: #f1f1f1;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.06);
}

.progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.progress-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #333;
    font-weight: bold;
}

.progress-title i {
    color: #409EFF;
}

.progress-value {
    font-size: 13px;
    color: #666;
}

.custom-progress .el-progress-bar__outer {
    background-color: #e8f5e9;
    border-radius: 4px;
    height: 10px !important;
}

.custom-progress .el-progress-bar__inner {
    border-radius: 4px;
    transition: width 0.5s ease-in-out;
}
.data-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 30px;
    overflow-x: auto;
    gap: 7px;

}
.data-block {

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  min-width: calc(33.33% - 20px);
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  height: 150px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  margin-right: 0;
    gap: 10px;
}



.data-item {
  text-align: center;
  flex: 1;
  min-width: 150px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.data-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.data-item:nth-child(1) h3 {
  color: #f56c6c;
}

.data-item:nth-child(2) h3 {
  color: #67c23a;
}
.hover-layer {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #98caff, #98caff);
    transform: scale(0); /* 初始状态：隐藏 */
    transform-origin: center center; /* 缩放中心为中间 */
    opacity: 0.6;
    transition: all 0.4s ease-in-out;
    z-index: 0;
}

.data-item:hover .hover-layer {
    transform: scale(1); /* 放大铺满 */
    opacity: 1;
}

.data-item:nth-child(1):hover .hover-layer,
.data-item:nth-child(2):hover .hover-layer {
  left: 0;
}

.data-item h3 {
    font-size: 28px;
    color: #333;
    margin: 0;
    font-weight: bold;
}

.data-item p {
    font-size: 14px;
    color: #888;
    margin-top: 6px;
}

@media (max-width: 768px) {
    .data-row {
        flex-direction: column;
        align-items: stretch;
    }

    .data-block {
        width: 33.2%;
        margin-right: 0;
        border: 8px;
        padding-left: 2px;
        padding-right: 2px;
    }

    .data-block:last-child {
        margin-bottom: 0;
    }
}

.header-row {
    display: flex;
    justify-content: space-between; /* 左右贴边 */
    align-items: center;            /* 垂直居中 */
    width: 100%;
}

/* 可选：控制按钮组间距 */
.button-group-wrapper .el-button + .el-button {
    margin-left: 8px;
}


</style>
